import $axios from '@/axios-instance.js'

export const priceListProjectService = {
  getByProjectId,
  savePriceList
}

function getByProjectId (id) {
  return $axios.get(`${process.env.ROOT_API}/price-lists/get-price-list-project/${id}`).then(response => {
    return response.data
  })
}

function savePriceList (priceList) {
  return $axios.post(`${process.env.ROOT_API}/price-lists/save-price-list-project`, priceList).then(response => {
    return response.data
  })
}



// WEBPACK FOOTER //
// ./src/services/price-list-project.service.js